<template>
  <div id="main">
    <div id="topGlass" :style="{opacity: !isSpecialPage ? (isHome && (goTopShow || cursorInTop) ? 1 : 0) : (cursorInTop ? 1 : 0)}"></div>
    <div id="top" :class="[isHome ? 'transparent' : 'white']" @mouseenter="cursorInTop = true"
         @mouseleave="cursorInTop = false">
      <img v-if="isHome" class="logo" :src='require("@/assets/img/index/logo.png")' @click='checkMenu("/home")'/>
      <img v-else class="logo" :src='require("@/assets/img/index/logo-white.png")' @click='checkMenu("/home")'/>
      <div id="menu" :class="isHome ? '' : 'white'">
        <div class="menu-item product"
             @click='checkMenu("/product/l30")'
             :class='(activeMenu.indexOf("/product") == 0 && activeMenu.indexOf("/product/e") == -1) || hover.detailType=="product" ? "active" : ""'
             @mouseenter='enterMenu("product")' @mouseleave='leaveMenu("product")'>
          <span class="text">产品</span>

          <div class="top-hover-product" :class="isHome ? 'home' : ''">
            <div id="product-detail" v-if='hover.type=="product"' @mouseenter='enterMenuDetail("product")'
                 @mouseleave="leaveMenuDetail('product')">

              <p class="product-detail-item wrightin-l30" @click.stop='checkMenu("/product/l30")'>
                  <b class="img-container">
                      <img :src="require('@/assets/img/index/product-l30.png')"/>
                  </b>
                  <span>Lumina 耀雅系列<br/>L30</span>
                  <img class="new-icon" :src="require('@/assets/img/index/new-icon.png')"/>
              </p>
              <p class="product-detail-item e10" @click.stop='checkMenu("/product/e10")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-e10.png')"/>
                </b>
                <span>Evolve 进化系列<br/>E10</span>
              </p>
              <p class="product-detail-item wrightin-t20" @click.stop='checkMenu("/product/t20")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-t20.png')"/>
                </b>
                <span>Touch 轻触系列<br/>T20</span>
              </p>
              <p class="product-detail-item wrightin-h30" @click.stop='checkMenu("/product/h30")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-h30.png')"/>
                </b>
                <span>H30 series</span>
              </p>
              <p class="product-detail-item wrightin-luolan" @click.stop='checkMenu("/product/luolan")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-luolan.png')"/>
                </b>
                <span>洛澜</span>
              </p>
              <p class="product-detail-item wrightin-two" @click.stop='checkMenu("/product/wrightinTwo")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-wrightinTwo.png')"/>
                </b>
                <span>T20 Max</span>
              </p>
              <p class="product-detail-item kegel" @click.stop='checkMenu("/product/kegel")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/product-kegel.png')"/>
                </b>
                <span>凯格尔球</span>
              </p>
            </div>
          </div>
        </div>
        <div class="menu-item technology"
             :class='activeMenu=="/technology" || hover.detailType=="technology" ? "active" : ""'
             @click='checkMenu("/technology")'
             @mouseenter='enterMenu("technology")' @mouseleave='leaveMenu("technology")'>
          <span class="text">医研科技</span>

          <div class="top-hover-technology" :class="isHome ? 'home' : ''">
            <div id="technology-detail" v-if='hover.type=="technology"' @mouseenter='enterMenuDetail("technology")'
                 @mouseleave="leaveMenuDetail('technology')" :style="{marginLeft: pageBottomDisplay == 'flex' ? '0' : (scrollbarWidth / 2 + 'px')}">
              <p class="technology-detail-item" @click.stop='checkMenu("/app")'>
                澜渟 App
              </p>
              <p class="technology-detail-item" @click.stop='checkMenu("/technology")'>
                科研技术
              </p>
            </div>
          </div>
        </div>
        <div class="menu-item about"
             :class='activeMenu.indexOf("/about")==0 || hover.detailType=="about" ? "active" : ""'
             @click='checkMenu("/about/info")'
             @mouseenter='enterMenu("about")' @mouseleave='leaveMenu("about")'>
          <span class="text">认识澜渟</span>

          <div class="top-hover-about" :class="isHome ? 'home' : ''">
            <div id="about-detail" v-if='hover.type=="about"' @mouseenter="enterMenuDetail('about')"
                 @mouseleave="leaveMenuDetail('about')">
              <p class="about-detail-item" @click.stop='checkMenu("/about/info")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/about-info.png')"/>
                </b>
                <span>公司简介</span>
              </p>
              <p class="about-detail-item" @click.stop='checkMenu("/about/consultation")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/about-consultation.png')"/>
                </b>
                <span>品牌资讯</span>
              </p>
              <p class="about-detail-item" @click.stop='checkMenu("/about/contact")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/about-contact.png')"/>
                </b>
                <span>联系我们</span>
              </p>
              <p class="about-detail-item" @click.stop='checkMenu("/about/join")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/about-join.png')"/>
                </b>
                <span>加入我们</span>
              </p>
              <p class="about-detail-item" @click.stop='checkMenu("/about/responsibility")'>
                <b class="img-container">
                  <img :src="require('@/assets/img/index/about-responsibility.png')"/>
                </b>
                <span>社会责任</span>
              </p>
            </div>
          </div>
        </div>
        <div class="menu-item empower" :class='activeMenu.indexOf("/empower")==0?"active":""'
             @click='checkMenu("/empower")'
             @mouseenter='enterMenu("empower")' @mouseleave='leaveMenu("empower")'>
          <span class="text">授权查询</span>
        </div>
      </div>
      <span id="hotLine" :class="[isHome ? 'home' : '']">
        <span class="text">服务热线：400-133-5668</span>
        <span class="img" @click='openUrl("https://lanting.tmall.com")'></span>
      </span>
    </div>

    <div id="content" :class="[isHome ? 'home-content' : '']">
      <router-view ref="page" @rollInit="rollInitEvent" @rollEnd="rollEndEvent" @rollTop="rollTopEvent"
        @rollPage="rollPageEvent"
        v-model="rollDisable"
      />
    </div>
    <div class="home-tel" v-if="isHome" :style="{display: pageBottomDisplay}" @click='checkMenu("/about/contact")'>
      <img alt :src="require('@/assets/img/index/home-tel.png')"/>
      <p>线下经销商合作</p>
      <div>
        <div class="bg"></div>
        <div class="mask"></div>
        <div class="text">
          招商电话：18021397056 <img alt :src="require('@/assets/img/home/mall-to.png')"/>
        </div>
      </div>
    </div>
    <div class="t20-other" v-if="activeMenu == '/product/t20'"
         :style="{display: pageBottomDisplay == 'flex' ? 'block' : 'none'}">

      <div class="system">
        <full-swiper-v2 :datas="systemList"></full-swiper-v2>
      </div>

      <div class="tech">
        <video v-animate="{
             name: 'zoomIn',
          }"
               src="//download.wrightin.com/website/product-t20-4.mp4" muted autoplay loop
               @contextmenu.prevent
               playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
        ></video>
        <div class="img-copyright" style="right: 0.9rem;bottom: 0.44rem;"></div>
      </div>

      <div class="pattern">
        <div class="left">
          <img alt :src="require('@/assets/img/product/t20/pattern-left.png')"/>
          <p>神经肌肉电刺激</p>
          <p>采用双向对称方波技术，通过电刺激引起盆底肌肉被动收缩，改善盆底血液循环。</p>
        </div>
        <div class="right">
          <!--            <video src="//download.wrightin.com/website/product-e10-2.mp4" autoplay muted loop-->
          <!--                   @contextmenu.prevent-->
          <!--                   playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true"-->
          <!--                   x5-playsinline="true"-->
          <!--            ></video>-->
          <img alt :src="require('@/assets/img/product/t20/pattern-right.png')"/>
          <p>肌电生物反馈</p>
          <p>通过阴道电极采集盆底肌表面的肌电信号转化为可视化图像，当收缩肌力达到预设的阈值，智能触发电刺激，增强肌肉的反应和锻炼效果。</p>
        </div>
        <div class="img-copyright">
          广告审查批准文号:苏械广审(文)第270509-08266号 盆底康复治疗仪 医疗器械注册号:苏械注准20242090347<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="mechanism">
        <p>6大作用机理</p>
        <img-swiper-v7 :datas="mechanismList"></img-swiper-v7>
        <div class="img-copyright">
          广告审查批准文号:苏械广审(文)第270509-08973号 盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="four-advantages">
          <div
              class="feature-card"
              v-for="(item, index) in advantagesList"
              :key="index"
              @mouseenter="handleMouseEnter(index)"
              @mouseleave="handleMouseLeave(index)"
          >
            <!-- 图片容器 -->
            <div class="card-img">
              <img :src="item.path" alt/>
            </div>
            <!-- 文字容器（带滑动动画） -->
            <div class="text-wrap" :class="{ slide: hoverIndex === index }">
              <p class="main-text">{{ item.title }}</p>
              <p class="sub-text">{{ item.desc }}</p>
            </div>
            <div class="word" v-html="item.word"></div>
          </div>
      </div>
      <div class="wireless">
        <video src="//download.wrightin.com/website/product-t20-5.mp4" muted autoplay loop
               @contextmenu.prevent
               playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
               x5-playsinline="true"
        ></video>
        <img class="bg" alt :src="require('@/assets/img/product/t20/wireless-bg.png')"/>
<!--        <p class="title">无线体验升级 随享无拘无束</p>-->
      </div>
      <div class="four-technology">
        <div class="title">
          <p>4大技术加持</p>
          <p>科学守护女性盆底健康</p>
        </div>
        <div class="technology-show">
          <div
              class="feature-card"
              v-for="(item, index) in technologyList"
              :key="index"
          >
            <!-- 图片容器 -->
            <div class="card-img">
              <img :src="item.path" alt/>
            </div>
            <!-- 文字容器（带滑动动画） -->
            <div class="text-wrap" :class="{ slide: hoverIndex === index }">
              <p class="main-text">{{ item.title }}</p>
              <p class="sub-text">{{ item.desc}}</p>
            </div>
            <div class="word" v-html="item.word"></div>
          </div>
        </div>
        <div class="img-copyright">
          广告审查批准文号:苏械广审(文)第270509-08264号 盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="research">
        <img class="research-bg" alt :src="require('@/assets/img/product/t20/research-bg.png')"/>
        <p class="title">国际权威验证 专研盆底紧致</p>
        <p class="sub-title">《电刺激生物反馈在产后盆底 功能康复中的临床效果评价》</p>
        <div class="research-btn">尿失禁临床研究[1]</div>
        <div class="img-copyright"></div>
      </div>
      <div class="zhuanli">
        <img class="zhuanli-bg" alt :src="require('@/assets/img/product/t20/zhuanli-bg.png')"/>
        <p class="title">医疗器械认证及专利</p>
        <p class="sub-title">严苛品质</p>
        <div class="list">
          <div class="item">
            <p>盆底康复治疗仪</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>发明专利</p>
            <p>ZL 2023 1 1543573.4</p>
          </div>
          <div class="item">
            <p>发明专利</p>
            <p>ZL 2023 1 0913296.5</p>
          </div>
          <div class="item">
            <p>发明专利</p>
            <p>ZL 2023 1 1802368.5</p>
          </div>
          <div class="item">
            <p>外观设计专利</p>
            <p>ZL202330448897.4</p>
          </div>
          <div class="item">
            <p>外观设计专利</p>
            <p>ZL 2023 3 0481048.9</p>
          </div>
        </div>
      </div>
    </div>
    <div class="e10-other" v-if="activeMenu == '/product/e10'"
         :style="{display: pageBottomDisplay == 'flex' ? 'block' : 'none'}">
      <div class="sm-ck">
        <div class="left">
          <img alt :src="require('@/assets/img/product/e10/left.png')"/>
          <p>治疗阴道松弛症</p>
          <div class="img-copyright" style="bottom: 0.08rem;">广告审查批准文号:苏械广审(文)第270228-03665号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
        <div class="right">
          <video src="//download.wrightin.com/website/product-e10-2.mp4" autoplay muted loop
                 @contextmenu.prevent
                 playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
                 x5-playsinline="true"
          ></video>
          <p>腹直肌分离治疗</p>
          <div class="img-copyright" style="bottom: 0.08rem;">广告审查批准文号:苏械广审(文)第270527-12256号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </div>
      <div class="full-video">
        <video src="//download.wrightin.com/website/product-e10-3.mp4" autoplay muted loop
               @contextmenu.prevent
               playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
               x5-playsinline="true"
        ></video>
        <p class="title">生电联合技术</p>
        <p class="sub-title">激活细胞活性，肌肉收放自如</p>
        <div class="img-copyright" style="right: 0.9rem;">广告审查批准文号:苏械广审(视)第270213-02323号 盆底康复治疗仪
          医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="spec">
        <p class="title">贴心守护</p>
        <img class="person" alt :src="require('@/assets/img/product/e10/person.png')"/>
        <div class="content">
          <div class="top">
            <img alt :src="require('@/assets/img/product/e10/spec-top.png')"/>
            <div class="title">硅胶材质</div>
            <div class="sub-title">亲肤舒适体验</div>
          </div>
          <div class="bottom">
            <div class="left">
              <img alt :src="require('@/assets/img/product/e10/spec-left.png')"/>
              <div class="title">专属电极</div>
              <div class="sub-title">专人独享</div>
            </div>
            <div class="right">
              <div class="top">
                <img alt :src="require('@/assets/img/product/e10/spec-right-top.png')"/>
                <div class="title">肌电体验</div>
                <div class="sub-title">盆底肌肌电评估<br/>肌电触发<br/>电刺激治疗</div>
              </div>
              <div class="bottom">
                <img alt :src="require('@/assets/img/product/e10/spec-right-bottom.png')"/>
                <div class="title">训练计划</div>
              </div>
            </div>
          </div>
        </div>
        <div class="img-copyright" style="color: #999;">广告审查批准文号:苏械广审(文)第270513-10953号 盆底康复治疗仪
          医疗器械注册号:苏械注准20252090043 盆底评估训练软件:苏械注准20242212280<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="zhuanli">
        <img class="zhuanli-bg" alt :src="require('@/assets/img/product/e10/zhuanli.png')"/>
        <p class="title">国家医疗器械认证</p>
        <p class="sub-title">严苛品质</p>
        <div class="list">
          <div class="item">
            <p>盆底康复治疗仪</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>盆底评估训练软件</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>阴道电极</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>理疗用体表电级</p>
            <p>一类医疗器械备案</p>
          </div>
        </div>
      </div>
    </div>
    <div class="h30-other" v-if="activeMenu == '/product/h30'"
         :style="{display: pageBottomDisplay == 'flex' ? 'block' : 'none'}">
      <div class="zhuanli">
        <img class="zhuanli-bg" alt :src="require('@/assets/img/product/h30/zhuanli.png')"/>
        <p class="title">医疗器械认证及专利</p>
        <p class="sub-title">严苛品质</p>
        <div class="list">
          <div class="item">
            <p>盆底康复治疗仪</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>盆底评估训练软件</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>发明专利</p>
            <p>ZL 2023 1 1543573.4</p>
          </div>
          <div class="item">
            <p>发明专利</p>
            <p>ZL 2023 1 1802368.5</p>
          </div>
        </div>
      </div>
    </div>
    <div class="luolan-other" v-if="activeMenu == '/product/luolan'"
         :style="{display: pageBottomDisplay == 'flex' ? 'block' : 'none'}">
      <div id="human" class="human" @mousewheel="mousewheel">
        <div class="human-text luolan-text">更多人性化设计</div>
        <div class="human-list-viewer">
          <div id="humanListOne" class="human-list-1">
            <div class="human-item">
              <img class="human-img" :src="require('@/assets/img/product/luolan/human-1.png')"/>
              <div class="human-text">保值</div>
              <div class="human-sub-text">OTA 远程升级<br/>系统功能一键迭代</div>
            </div>
            <div class="human-item human-item-right">
              <img class="human-img" :src="require('@/assets/img/product/luolan/human-2.png')"/>
              <div class="human-text">省心</div>
              <div class="human-sub-text">2350mAh 电池<br/>大容量超长续航</div>
            </div>
            <div class="human-item">
              <img class="human-img" :src="require('@/assets/img/product/luolan/human-3.png')"/>
              <div class="human-text">保值</div>
              <div class="human-sub-text">蓝牙 5.1 高效传输</div>
            </div>
          </div>
          <div id="humanListTwo" class="human-list-2">
            <div class="human-item">
              <img class="human-img" :src="require('@/assets/img/product/luolan/human-4.png')"/>
              <div class="human-text">省时</div>
              <div class="human-sub-text">三通道设计<br/>同时满足多部位修复</div>
            </div>
            <div class="human-item">
              <img class="human-img" :src="require('@/assets/img/product/luolan/human-5.png')"/>
              <div class="human-text">智能</div>
              <div class="human-sub-text">LED 大屏<br/>操作信息可视化</div>
            </div>
          </div>
        </div>
        <div class="human-copyright">
          广告审查批准文号：苏械广审(文)第270314-04937号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
          请仔细阅读产品说明书或者在义务人员的指导下购买和使用禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="zhuanli">
        <img class="zhuanli-bg" alt :src="require('@/assets/img/product/luolan/zhuanli.png')"/>
        <p class="title">国家医疗器械认证</p>
        <p class="sub-title">严苛品质</p>
        <div class="list">
          <div class="item">
            <p>盆底康复治疗仪</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>盆底康复训练软件</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>阴道电极</p>
            <p>二类医疗器械</p>
          </div>
          <div class="item">
            <p>理疗用体表电极</p>
            <p>一类医疗器械备案</p>
          </div>
        </div>
      </div>
    </div>

<!--    TODO L30 -->
    <div class="l30-other" v-if="activeMenu == '/product/l30'"
         :style="{display: pageBottomDisplay == 'flex' ? 'block' : 'none'}">
      <div class="product-grid">
        <!-- 产品特性卡片容器 -->
        <div
            class="feature-card"
            v-for="(item, index) in videoList"
            :key="index"
            @mouseenter="handleMouseEnter(index)"
            @mouseleave="handleMouseLeave(index)"
        >
          <!-- 图片容器 -->
          <div class="card-img">
            <video :src="item.path"
                   :poster="item.path + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'"
                   muted autoplay loop @contextmenu.prevent
                   playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
                   x5-playsinline="true">
            </video>
            <!-- 遮罩层 -->
            <div class="mask" :class="{ active: hoverIndex === index }"></div>
          </div>
          <!-- 文字容器（带滑动动画） -->
          <div class="text-wrap" :class="{ slide: hoverIndex === index }">
            <p class="main-text">{{ item.title }}</p>
            <p class="sub-text" v-show="hoverIndex === index">{{ item.subtitle }}</p>
          </div>
          <div class="word" v-html="item.word"></div>
        </div>
        <div class="img-copyright">
          广告审查批准文号:苏械广审(文)第270509-05585号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="course">
        <full-swiper-v1 :datas="courseList"></full-swiper-v1>
        <div class="img-copyright" >
          广告审查批准文号：苏械广审(文)第270509-04692号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="advantage-pdj">
        <div class="title">
          <p>下一代盆底康复治疗仪·专注提升「盆底肌」</p>
          <p>
            <span>肌电压力双重评估</span>&nbsp&nbsp&nbsp
            <span>科学强健盆底肌</span>
          </p>
        </div>
        <img-swiper-v5 :datas="advantageList"></img-swiper-v5>
      </div>

      <div class="rejuvenation">
        <video src="//download.wrightin.com/train_prepare_video/wrightin-l30-rejuvenation.mp4"
               @contextmenu.prevent
               autoplay muted loop playsinline preload="auto"
               x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true">
        </video>
        <div class="about">
          <p>下一代盆底康复治疗仪·「私密抗衰」</p>
          <p>
            <span>科学修护内外阴</span>
            <span>多维度私密抗衰</span>
          </p>
        </div>
        <div class="page-img-copyright">
          广告审查批准文号：苏械广审(文)第270509-05578号
          盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书
          南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="repair-improve">
        <div class="title">
          <p>
            <span>三层立体奢护</span>&nbsp&nbsp&nbsp
            <span>专项修复提升</span>
          </p>
        </div>
        <img alt="" :src="require('@/assets/img/product/l30/repair-improve.png')">
      </div>

      <div class="vagina-improve">
        <div class="title">
          <p>
            <span>四维内阴提升</span>&nbsp;&nbsp;&nbsp;
            <span>构筑私密健康</span>
          </p>
        </div>
        <div class="four-intravaginal-list">
          <div v-for="item in fourIntravaginalList" class="intravaginal-item">
            <video :src="item.path" muted autoplay loop preload="auto"
                   @contextmenu.prevent
                   playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
            <div class="title" v-html="item.title"></div>
          </div>
        </div>
        <div class="page-img-copyright">
          广告审查批准文号：苏械广审(文)第270509-05579号
          盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书
          南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="vulva-repair">
        <div class="title">
          <p>双重外阴修复</p>
          <p>打造专属私密健康方案</p>
          <p>外阴电极片联合<br/>协同刺激，增强外阴闭合能力</p>
        </div>
        <img alt="" :src="require('@/assets/img/product/l30/vulva-repair.png')">
        <video src="//download.wrightin.com/train_prepare_video/wrightin-l30-vulva-repair.mp4" muted autoplay loop preload="auto"
               @contextmenu.prevent
               playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
        <div class="copyright">
          广告审查批准文号:苏械广审(视)第270509-05604号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="soothing-massage">
        <div class="title">
          <p>舒缓按摩 肌肉放松</p>
          <p>缓解多种亲密困扰</p>
          <p>缓解亲密痛疼，提高女性私密健康功能</p>
        </div>
        <video src="//download.wrightin.com/train_prepare_video/wrightin-soothing-massage.mp4" muted autoplay loop preload="auto"
               @contextmenu.prevent
               playsinline="true" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"/>
        <div class="copyright">
          广告审查批准文号:苏械广审(视)第270509-05580号 盆底康复治疗仪 医疗器械注册号:苏械注准20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="diastasis-recti">
        <img alt="" :src="require('@/assets/img/product/l30/diastasis-recti.png')">
        <div class="about">
          <p>下一代盆底康复治疗仪·多方面「塑形养护」</p>
          <p>多维科技系统</p>
          <p>修复腹直肌分离</p>
        </div>
        <div class="page-img-copyright">
          广告审查批准文号：苏械广审(文)第270509-05584号
          盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书
          南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="electrode-pad">
        <img alt="" :src="require('@/assets/img/product/l30/electrode-pad.png')">
        <div class="about">
          <p>0.5-10000Hz超宽频脉冲</p>
          <p>多方位科学塑形</p>
          <p>配置多功能电极片</p>
          <p>五大核心波形技术，智能匹配不同需求</p>
        </div>
        <div class="page-img-copyright">
          广告审查批准文号：苏械广审(文)第270509-04694号
          盆底康复治疗仪  医疗器械注册证编号:苏械注准 20262090138<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用
          禁忌内容或者注意事项详见说明书
          南京麦豆健康科技有限公司
        </div>
      </div>

      <div class="advantage">
        <img-swiper-v6 :datas="scienceList"></img-swiper-v6>
      </div>

      <div class="international-certification">
        <div class="title">
          <p>
            <span>国际权威验证</span>&nbsp;&nbsp;&nbsp;
            <span>盆底治疗效果提升</span>
          </p>
          <p>《生殖医学杂志》文献发表</p>
        </div>
        <img alt="" :src="require('@/assets/img/product/l30/international-certification.png')">
      </div>

      <div class="patent34">
        <div class="title">
          <p>34大专利权威认证</p>
        </div>
        <img alt="" :src="require('@/assets/img/product/l30/patent34.png')">
      </div>

      <div class="medical-patent">
        <div class="title">
          <p>医疗器械认证及专利</p>
          <p>严苛品质</p>
        </div>
        <img alt="" :src="require('@/assets/img/product/l30/medical-patent.png')">
      </div>

    </div>

    <div id="pageBottom" :style="{display: pageBottomDisplay}">
      <div class="top">
        <img alt :src='require("@/assets/img/index/logo.png")' @click='checkMenu("/home")'/>
      </div>
      <div class="content">
        <div class="left">
          <div class="social-media">
            <div class="normal-text">社交媒体</div>
            <div class="list">
              <template v-for="(socialMedia, index) in socialMediaConfig">
                <div @mouseenter="hoverImgShow($event, socialMedia.name)" @mouseleave="hoverImgHide"
                     class="item" :class="socialMedia.name"></div>
              </template>
            </div>
          </div>
          <div class="contact">
            <div class="item">
              <div class="normal-text">服务热线：周一至周日 9:00-18:00</div>
              <div class="big-text">400-133-5668</div>
            </div>
            <div class="gap">
              <div class="line"></div>
            </div>
            <div class="item">
              <div class="normal-text">经销合作：</div>
              <div class="big-text">18021397056</div>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="link-group" v-for="(linkGroup, linkGroupIndex) in bottomLinkConfig" :key="linkGroupIndex">
            <div class="title normal-text">{{ linkGroup.group }}</div>
            <div class="link-list">
              <div class="link-item" v-for="(linkItem, linkIndex) in linkGroup.linkList" :key="linkIndex">
                <span class="small-text" v-if="linkGroup.type=='menu'"
                      @click="checkMenu(linkItem.link)">{{ linkItem.name }}</span>
                <span class="small-text" v-else @click="openUrl(linkItem.link)">{{ linkItem.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title normal-text">下载应用</div>
          <div class="app-list">
            <div class="app-item" @mouseenter="hoverImgShow($event, '', 'app')" @mouseleave="hoverImgHide">
              <img alt :src="require('@/assets/img/index/app-lt.png')"/>
              <span class="text small-text active">澜渟 APP</span>
            </div>
            <div class="app-item" @mouseenter="hoverImgShow($event, '', 'app-doctor')" @mouseleave="hoverImgHide">
              <img alt :src="require('@/assets/img/index/app-ltd.png')"/>
              <span class="text small-text active">澜渟医生 APP</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <p>互联网药品信息服务资格证书：(苏)-非经营性-2023-0070</p>
        <p @click='openUrl("https://beian.miit.gov.cn/#/Integrated/index")'>Copyright © 2013-{{ copyRightYear }}
          南京麦豆健康科技有限公司 版权所有 苏ICP备 17044321 号</p>
        <p>投诉举报电话: 12331</p>
      </div>
      <div class="hover-img"
           :style="{display: hoverImg.isShow ? 'block' : 'none', top: hoverImg.top, left: hoverImg.left}">
        <img :src="hoverImg.qrcodePath" alt="二维码"/>
        <img :src="require('@/assets/img/index/angle.png')" alt class="angle">'
      </div>
    </div>
    <div id="goTop" v-if="goTopShow" @click="goTop()" :class="toBottom ? 'white' : ''">
      <img class="img" v-if="!toBottom" :src='require("@/assets/img/index/to-top.png")'>
      <img class="img-white" v-else :src='require("@/assets/img/index/to-top-white.png")'>
    </div>
  </div>
</template>

<script>
import { FullSwiperV1 } from '@/components/full-swiper-v1';
import { ImgSwiperV5 } from "@/components/img-swiper-v5";
import { ImgSwiperV6 } from "@/components/img-swiper-v6";
import { ImgSwiperV7 } from "@/components/img-swiper-v7";
import {FullSwiperV2} from "@/components/full-swiper-v2";
export default {
  data() {
    return {
      isSpecialPage: false,
      cursorInTop: false,
      activeMenu: '/home',
      hover: {
        type: 'product',
        isShow: false,
      },
      rollDisable: false,
      scrollTop: 0,
      pageBottomDisplay: 'none',
      rollPage: 1,
      goTopShow: false,
      toBottom: false,
      copyRightYear: new Date().getFullYear(),
      hoverImg: {
        isShow: false,
        qrcodePath: '',
        top: 0,
        left: 0,
      },
      isHome: true,
      socialMediaConfig: [
        {
          name: 'wechat',
          type: 'qrcode',
        },
        {
          name: 'tiktok',
          type: 'qrcode',
        },
        {
          name: 'xiaohongshu',
          type: 'qrcode',
        },
        {
          name: 'weibo',
          type: 'qrcode',
        },
        {
          name: 'zhihu',
          type: 'qrcode',
        },
      ],
      bottomLinkConfig: [
        {
          group: '澜渟产品',
          type: 'menu',
          linkList: [
            {
              name: 'Lumina耀雅系列 L30',
              link: '/product/l30',
            },
            {
              name: 'Evolve进化系列 E10',
              link: '/product/e10',
            },
            {
              name: 'Touch轻触系列 T20',
              link: '/product/t20',
            },
            {
              name: 'H30 series',
              link: '/product/h30',
            },
            {
              name: '洛澜',
              link: '/product/luolan',
            },
            {
              name: 'T20 Max',
              link: '/product/wrightinTwo',
            },
            {
              name: '凯格尔球',
              link: '/product/kegel',
            },
          ],
        },
        {
          group: '医研科技',
          type: 'menu',
          linkList: [
            {
              name: '澜渟 App',
              link: '/app',
            },
            {
              name: '核心技术',
              link: '/technology',
            },
          ],
        },
        {
          group: '关于我们',
          type: 'menu',
          linkList: [
            {
              name: '公司简介',
              link: '/about/info',
            },
            {
              name: '品牌资讯',
              link: '/about/consultation',
            },
            {
              name: '联系我们',
              link: '/about/contact',
            },
            {
              name: '加入我们',
              link: '/about/join',
            },
            {
              name: '社会责任',
              link: '/about/responsibility',
            },
          ],
        },
        {
          group: '友情链接',
          type: 'friend',
          linkList: [
            {
              name: '麦澜德',
              link: 'https://www.medlander.com',
            },
            {
              name: '佳澜健康',
              link: 'http://www.jialan365.com',
            },
            {
              name: '锐诗得',
              link: 'http://www.reseader.com',
            },
          ],
        },
      ],
      luolanHumanIndex: 1,
      luolanHumanChanging: false,
      scrollbarWidth: 0,
      // L30
      hoverIndex: -1, // 记录悬浮的卡片索引
      videoList: [
        {
          title: "更贴心",
          subtitle: "医用级硅胶",
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-1.mp4",
        },
        {
          title: "更多维",
          subtitle: "三维盆底\n智能评估系统",
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-2.mp4",
        },
        {
          title: "更智能",
          subtitle: "CES离心电刺激*\n舒缓按摩，肌肉放松\n智能抗阻凯格尔训练",
          word: "CES离心电刺激*：指(Centrifugal Electrical Stimulation,CES)",
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-3.mp4",
        },
        {
          title: "更科学",
          subtitle: "智能变频脉冲\nWTR*智能训练",
          word: "WTR*：指热身-训练-放松(Warm up-Train-Relax,WTR)",
          path: "//download.wrightin.com/train_prepare_video/wrightin-product-l30-4.mp4",
        },
      ],
      courseList: [
        {
          path: require('@/assets/img/product/l30/course1.png'),
          title: '',
          desc: '',
        },
        {
          path: require('@/assets/img/product/l30/course2.png'),
          title: '',
          desc: '',
        },
        {
          path: require('@/assets/img/product/l30/course3.png'),
          title: '',
          desc: '',
        },
      ],
      advantageList: [
        {
          path: require("@/assets/img/product/l30/advantage1.png"),
          title: "国际标准Glazer模板<br/>6大维度35项指标科学评估",
          words: '广告审查批准文号:苏械广审(文)第270509-04693号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/advantage2.png"),
          title: "大数据智能算法<br/>动态构建综合性解决方案",
          words: '广告审查批准文号:苏械广审(文)第270509-05605号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/advantage3.png"),
          title: "十大训练模式<br/>辅助改善盆底状态",
          words: '广告审查批准文号:苏械广审(文)第270509-06469号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/advantage4.png"),
          title: "盆底疲劳智能监测<br/>科学调整训练难度",
          words: '广告审查批准文号:苏械广审(文)第270509-05583号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/advantage5.png"),
          title: "WTR科学训练流程<br/>改善盆底肌肉状态",
          words: '广告审查批准文号:苏械广审(文)第270509-06476号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        }
      ],
      fourIntravaginalList: [
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-1.mp4',
          title: '私密紧致提升'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-2.mp4',
          title: '私密敏感激活'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-3.mp4',
          title: '私密水润如初'
        },
        {
          path: '//download.wrightin.com/train_prepare_video/mobile-wrightin-l30-health-4.mp4',
          title: '私密快感提升'
        }
      ],
      scienceList: [
        {
          path: require("@/assets/img/product/l30/science1.png"),
          title: "六重智能侦测系统<br/>层层把关 全程相伴",
        },
        {
          path: require("@/assets/img/product/l30/science2.png"),
          title: "个性化定制方案的澜渟APP<br/>丰富功能 一键训练",
          words: '广告审查批准文号:苏械广审(文)第270509-04695号 盆底康复治疗仪 医器械注册号:苏械注准20262090138<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require("@/assets/img/product/l30/science3.png"),
          title: "悬浮智控主机<br/>30天超长续航",
        },
        {
          path: require("@/assets/img/product/l30/science4.png"),
          title: "多V1陪伴 终身护航<br/>GMAA认证医学顾问",
        }
      ],
      mechanismList: [
        {
          path: require('@/assets/img/product/t20/mechanism-1.png'),
          title: '智能生物反馈<br/>自主掌控盆底状态',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-2.png'),
          title: '修复盆底损伤肌肉<br/>提升两性生活质量',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-3.png'),
          title: '科学脉冲技术<br/>兴奋神经肌肉组织',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-4.png'),
          title: '低频脉冲电流<br/>引起肌肉收缩锻炼肌肉',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-5.png'),
          title: '促进局部血液循环<br/>和消肿',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-6.png'),
          title: '双重镇痛机制<br/>阻断、干扰疼痛传导',
        },
      ],
      advantagesList: [
        {
          path: require('@/assets/img/product/t20/advantages-1.png'),
          title: '智能评估全面分析',
          desc: '国际标准Glazer评估+FSFI量表\n盆底系统+私密系统',
          word: '广告审查批准文号：苏械广审(文)第270509-08977号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-2.png'),
          title: '千人千面 专属定制',
          desc: 'AI个性化定制算法 动态调整\n方案参数 打造专属健康方案',
          word: '广告审查批准文号：苏械广审(文)第270509-08207号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-3.png'),
          title: '主动训练 被动刺激\n激活本体感觉',
          desc: '五大训练模式 无缝衔接连续治疗',
          word: '广告审查批准文号：苏械广审(文)第270509-08986号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-4.png'),
          title: '两大智能监测系统',
          word: '广告审查批准文号：苏械广审(文)第270509-08586号 盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司'
        },
      ],
      technologyList: [
        {
          path: require('@/assets/img/product/t20/technology-1.png'),
          title: '无线一体化设计',
          desc: '一键开启 摆脱有线束缚',
        },
        {
          path: require('@/assets/img/product/t20/technology-2.png'),
          title: 'UVC紫外线消毒',
          desc: '7颗UVC灯珠 紫外线消毒',
        },
        {
          path: require('@/assets/img/product/t20/technology-3.png'),
          title: '探头加热振感',
          desc: '加热功能 温和促进局部血液循环 温柔震感提示',
        },
        {
          path: require('@/assets/img/product/t20/technology-4.png'),
          title: '充电收纳二合一',
          desc: '专属充电收纳仓 保护机身 长效护航',
        },
      ],
      systemList: [
        {
          path: require('@/assets/img/product/t20/system-1.png'),
          title: '',
          desc: '',
          words: '广告审查批准文号:苏械广审(文)第270509-08212号  盆底康复治疗仪  医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书  南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/system-2.png'),
          title: '',
          desc: '',
          words: '广告审查批准文号:苏械广审(文)第270509-08212号  盆底康复治疗仪  医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书  南京麦豆健康科技有限公司'
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.bindScrollWindow, true);

    // 1. 创建测试元素
    const testDiv = document.createElement('div');
    testDiv.style.cssText = `
    width: 100px;
    height: 100px;
    overflow: scroll; /* 强制显示滚动条 */
    position: absolute;
    top: -9999px; /* 隐藏在视口外 */
  `;

    // 2. 添加到页面并计算
    document.body.appendChild(testDiv);
    this.scrollbarWidth = testDiv.offsetWidth - testDiv.clientWidth;

    // 3. 清理临时元素
    document.body.removeChild(testDiv);
  },
  methods: {
    rollPageEvent(page) {
      if (page > (this.isHome ? 4 : 1)) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },

    rollInitEvent() {
      this.pageBottomDisplay = 'none';
      this.toBottom = false;
      this.rollDisable = false;
      this.$refs.page.currentPage = 1;
    },

    rollEndEvent() {
      this.pageBottomDisplay = 'flex';
    },

    rollTopEvent() {
      this.pageBottomDisplay = 'none';
      this.toBottom = false;
    },
    /**
     监听页面滚动条
     @param
     @return
     */
    bindScrollWindow() {
      this.scrollTop = window.scrollY;
      if (!this.goTopShow) {
        this.goTopShow = window.scrollY > window.screen.availHeight * .06;
      }
      const rem = document.documentElement.style.fontSize.replace('px', '') * 1;
      const fullHeight = window.innerHeight;
      const pageBottomTop = document.querySelector('#pageBottom').getBoundingClientRect().top;
      if (fullHeight - pageBottomTop > 1.15 * rem) {
        this.toBottom = true;
      } else {
        this.toBottom = false;
      }
      this.$nextTick(() => {
        this.rollDisable = this.scrollTop != 0 && this.pageBottomDisplay == 'flex';
      });
    },
    /**
     选中菜单
     @param {(url: string) => string} menu 菜单
     @return
     */
    checkMenu(menu) {
      if (this.activeMenu == menu) {
        this.goTop();
      } else {
        this.jump(menu);
      }
      this.leaveMenuDetail();
    },
    /**
     页面跳转
     @param {string} path 跳转路径
     @return
     */
    jump(path) {
      this.$router.push({path: path});
    },
    /**
     打开链接
     @param {string} url 链接
     @return
     */
    openUrl(url) {
      window.open(url);
    },
    /**
     置顶
     @param
     @return
     */
    goTop() {
      this.rollDisable = false;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      if (this.activeMenu == '/product/e10' ||
          this.activeMenu == '/product/t20' ||
          this.activeMenu == '/product/h30') {
        this.$refs.page.$refs.pageChild.currentPage = 1;
      } else {
        this.$refs.page.currentPage = 1;
      }
    },
    /**
     鼠标移入菜单
     @param {string} menu 菜单
     @return
     */
    enterMenu(menu) {
      this.hover.isShow = true;
      this.hover.type = menu;
    },
    /**
     鼠标移出菜单
     @param
     @return
     */
    leaveMenu(menu) {
      this.hover.isShow = false;
    },

    /**
     鼠标移入菜单详情
     @param
     @return
     */
    enterMenuDetail(detailType) {
    },
    /**
     鼠标移出菜单详情
     @param
     @return
     */
    leaveMenuDetail(menu) {
    },

    hoverImgShow(event, qrcodeName, appName = '') {
      if (this.hoverImg.isShow) {
        return;
      }
      const rem = document.documentElement.style.fontSize.replace('px', '') * 1;
      this.hoverImg.isShow = true;
      if (appName === '') {
        this.hoverImg.qrcodePath = require('@/assets/img/index/social-media/qrcode/' + qrcodeName + '.png');
      } else {
        this.hoverImg.qrcodePath = require('@/assets/img/index/qrcode-' + appName + '.png');
      }
      this.hoverImg.left = event.target.offsetLeft - (1.2 * rem - event.target.offsetWidth) / 2 + 'px';
      this.hoverImg.top = event.target.offsetTop - ((1.2 + 0.12 + 0.1) * rem) + 'px';
    },

    hoverImgHide() {
      this.hoverImg.isShow = false;
      this.hoverImg.left = 0;
      this.hoverImg.top = 0;
    },

    mousewheel(e) {
      if (this.luolanHumanChanging) {
        return;
      }
      const domHuman = document.getElementById('human');
      const domOne = document.getElementById('humanListOne');
      const domTwo = document.getElementById('humanListTwo');
      if (domOne == null || domTwo == null) {
        return;
      }

      if (e.deltaY < 0) {
        // 鼠标滚轮向上
        if (this.luolanHumanIndex == 1) {
          return;
        }
        if (domHuman.getBoundingClientRect().bottom < window.innerHeight) {
          return;
        }
        this.luolanHumanChanging = true;
        domOne.style.transform = 'translateY(0%)';
        domTwo.style.transform = 'translateY(0%)';
      } else {
        // 鼠标滚轮向下
        if (this.luolanHumanIndex == 2) {
          return;
        }
        if (domHuman.getBoundingClientRect().top > 0) {
          return;
        }
        this.luolanHumanChanging = true;
        domOne.style.transform = 'translateY(-9.48rem)';
        domTwo.style.transform = 'translateY(-9.48rem)';
      }

      setTimeout(() => {
        this.luolanHumanIndex = this.luolanHumanIndex == 1 ? 2 : 1;
        this.luolanHumanChanging = false;
      }, 500);
    },

    // L30
    handleMouseEnter(index) {
      this.hoverIndex = index;
    },
    handleMouseLeave() {
      this.hoverIndex = -1;
    },
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.goTopShow = false;
        this.activeMenu = newVal.path;
        if (this.activeMenu == '/home') {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
        if (this.activeMenu == '/home' ||
            this.activeMenu == '/product/e10' ||
            this.activeMenu == '/product/t20' ||
            this.activeMenu == '/product/h30') {
          this.pageBottomDisplay = 'none';
        } else {
          this.pageBottomDisplay = 'flex';
        }
      },
      immediate: true,
    },
  },
  components: {
    FullSwiperV2,
    FullSwiperV1,
    ImgSwiperV5,
    ImgSwiperV6,
    ImgSwiperV7,
  },
};
</script>

<style lang="scss" scoped>
:root {
  --animate-duration: 0.5s;
}

#main {
  height: 100%;
}

#topGlass {
  position: fixed;
  z-index: 98;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: .72rem;
  transition: all 0.3s linear;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: saturate(180%) blur(1rem);
  border-bottom: 0.01rem solid rgba(255, 255, 255, 0.1);
}

#top {
  position: fixed;
  z-index: 98;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: .72rem;

  &.transparent {
    background-color: transparent;
  }

  &.white {
    background-color: #fff;
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.1);
  }

  &.black {
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: saturate(180%) blur(1rem);
  }

  > .logo {
    position: absolute;
    top: 0.21rem;
    left: 0.9rem;
    cursor: pointer;
    height: 0.3rem;
  }

  > #menu {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 5.2rem;
    height: .72rem;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.white {
      > .menu-item {
        > .text {
          color: #333;
        }

        &:hover, &.active {
          &:after {
            background-color: #333;
          }
        }
      }
    }

    > .menu-item {
      position: relative;
      height: .72rem;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:after {
        content: "";
        display: block;
        position: absolute;
        top: 0.56rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 0;
        background-color: #fff;
        height: 0.02rem;
        -webkit-transition: all 0.3s linear;
        transition: all 0.3s linear;
      }

      > .text {
        font-weight: 400;
        font-size: 0.18rem;
        color: #fff;
        line-height: 0.25rem;
      }

      .top-hover-product,
      .top-hover-product-e,
      .top-hover-technology,
      .top-hover-about {
        position: fixed;
        z-index: 97;
        top: 0.72rem;
        left: 0;
        right: 0;
        overflow: hidden;
        height: 0;
        transition: all 0.2s linear;

        &.home {
          > #product-detail {
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: saturate(180%) blur(1rem);

            > .product-detail-item {
              > span {
                color: rgba(255, 255, 255, 0.8);
              }

              &:hover {
                > span {
                  color: #fff;
                }
              }
            }
          }

          > #about-detail {
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: saturate(180%) blur(1rem);

            > .about-detail-item {
              > span {
                color: rgba(255, 255, 255, 0.8);
              }

              &:hover {
                > span {
                  color: #fff;
                }
              }
            }
          }

          > #technology-detail {
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: saturate(180%) blur(1rem);

            > .technology-detail-item {
              color: rgba(255, 255, 255, 0.8);

              &:hover {
                color: #fff;
              }
            }
          }
        }

        > #product-detail {
          padding: 0 2.94rem;
        }

        > #product-detail {
          position: absolute;
          left: 0;
          right: 0;
          height: 2.28rem;
          background: rgba(255, 255, 255, 0.96);
          display: flex;
          justify-content: space-between;

          > .product-detail-item {
            width: 1.2rem;
            height: 1.34rem;
            position: relative;
            cursor: pointer;

            &:hover {
              > b {
                > img {
                  transform: scale(1.1);
                }
              }
            }

            > .new-icon {
              width: 0.29rem;
              z-index: 1;
              position: absolute;
            }

            > b {
              position: absolute;
              top: 0;
              width: 1.2rem;
              overflow: hidden;

              > img {
                transition: all 0.4s;
                width: 100%
              }
            }

            > span {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              text-align: center;
              font-weight: 400;
              font-size: 0.16rem;
              color: #666;
              line-height: 0.22rem;
            }

            &:hover {
              > span {
                color: #333;
              }
            }
          }
          > .product-detail-item {
            top: 0.32rem;
          }
          > .product-detail-item:nth-child(1), .product-detail-item:nth-child(2), .product-detail-item:nth-child(3) {
            height: 1.56rem;
          }
        }

        > #about-detail {
          position: absolute;
          left: 0;
          right: 0;
          height: 2.08rem;
          background: rgba(255, 255, 255, 0.96);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 4.26rem;

          > .about-detail-item {
            width: 1.48rem;
            height: 1.44rem;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            > .img-container {
              width: 1.48rem;
              height: 1.1rem;
              overflow: hidden;
              display: flex;
              border-radius: 0.08rem;

              > img {
                width: 100%;
                transition: all 0.4s;
              }
            }

            > span {
              text-align: center;
              line-height: .22rem;
              font-size: .16rem;
              color: #666;
            }

            &:hover {
              > span {
                color: #333;
              }

              > .img-container {
                > img {
                  transform: scale(1.1);
                }
              }
            }
          }
        }

        > #technology-detail {
          position: absolute;
          left: 7.95rem;
          height: 1.16rem;
          width: 1.8rem;
          background: rgba(255, 255, 255, 0.96);
          display: flex;
          flex-direction: column;
          align-items: center;

          > .technology-detail-item {
            height: 0.58rem;
            line-height: 0.58rem;
            font-size: 0.16rem;
          }
        }
      }

      &:hover, &.active {
        &:after {
          width: 100%;
        }

        > .text {
          font-weight: 500;
        }
      }

      &:hover {
        .top-hover-product,
        .top-hover-product-e {
          height: 1.98rem;
        }

        .top-hover-about {
          height: 2.08rem;
        }

        .top-hover-technology {
          height: 1.16rem;
        }
      }
    }
  }

  > #hotLine {
    position: absolute;
    top: .23rem;
    right: 0.9rem;
    width: 2.49rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .text {
      font-weight: 400;
      font-size: 0.18rem;
      color: #333;
      line-height: 0.25rem;
    }

    > .img {
      width: .2rem;
      height: .2rem;
      background: url(./assets/img/index/hotline-black.png) no-repeat center center;
      background-size: 100% 100%;
      cursor: pointer;
    }

    &.home {
      > .text {
        color: #fff;
      }

      > .img {
        background: url(./assets/img/index/hotline.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}

#content {
  clear: both;
  position: relative;
  padding-top: .72rem;
  min-height: 100%;

  &.home-content {
    padding-top: 0;
  }
}

.home-tel {
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 4.7rem;
  background-color: #fff;
  cursor: pointer;

  > img {
    position: absolute;
    top: 0;
    height: 100%;
    object-fit: cover;
  }

  > p:nth-child(2) {
    font-weight: 500;
    font-size: 0.56rem;
    color: #FFFFFF;
    line-height: 0.78rem;
    z-index: 1;
  }

  > div:nth-child(3) {
    padding: 0.06rem 0.24rem;
    border-radius: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    margin-top: 0.12rem;
    z-index: 1;

    &:hover, &:active, &:focus {
      > .bg {
        height: 0;
      }

      > .mask {
        height: 100%;
      }
    }

    > .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all .4s cubic-bezier(.4, 0, .2, 1);
      z-index: 1;
      background-color: transparent;
    }

    > .mask {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0;
      background-color: #7F4DC9;
      transition: all .4s cubic-bezier(.4, 0, .2, 1);
      z-index: 2;
    }

    > .text {
      z-index: 3;
      font-weight: 500;
      font-size: 0.28rem;
      color: #FFFFFF;
      line-height: 0.39rem;
      display: flex;
      align-items: center;
      justify-content: center;

      > img {
        margin-left: 0.17rem;
        width: 0.24rem;
      }
    }
  }
}

.t20-other {
  position: relative;
  background: #FAFBFE;

  .pattern {
    width: 100%;
    height: 100%;
    padding: 1rem 0.9rem;
    position: relative;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    > .left {
      position: relative;
      width: 8.5rem;
      height: 8.8rem;
      border-radius: 0.24rem;
      overflow: hidden;

      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      > p:nth-child(2) {
        position: absolute;
        left: 0.59rem;
        top: 0.8rem;
        font-weight: 500;
        font-size: 0.44rem;
        color: #FFFFFF;
        line-height: 0.62rem;
      }
      > p:nth-child(3) {
        width: 7.3rem;
        position: absolute;
        left: 0.59rem;
        top: 1.58rem;
        font-weight: 500;
        font-size: 0.28rem;
        color: #FFFFFF;
        line-height: 0.39rem;
      }
    }

    > .right {
      position: relative;
      width: 8.5rem;
      height: 8.8rem;
      border-radius: 0.24rem;
      overflow: hidden;


      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      > p:nth-child(2) {
        position: absolute;
        left: 0.59rem;
        top: 0.8rem;
        font-weight: 500;
        font-size: 0.44rem;
        color: #FFFFFF;
        line-height: 0.62rem;
      }
      > p:nth-child(3) {
        width: 7.3rem;
        position: absolute;
        left: 0.59rem;
        top: 1.58rem;
        font-weight: 500;
        font-size: 0.28rem;
        color: #FFFFFF;
        line-height: 0.39rem;
      }
    }

    > .img-copyright {
      color: #d4d4d4;
    }

  }

  > .mechanism {
    background: #fff;
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-y: center;
    padding-top: 0.5rem;
    padding-bottom: 0.7rem;

    > p {
      margin-bottom: 0.4rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
    }
    > .swiper {
      width: 100%;
      height: 7.6rem;
    }
    > .img-copyright {
      color: #d4d4d4;
    }
  }

  > .four-advantages {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding-top: 0.78rem;
    padding-bottom: 1.32rem;
    gap: 0.4rem;
    background: #fff;

    .img-copyright {
      bottom: 1rem;
    }

    /* 特性卡片：占比调整为2列布局 */
    > .feature-card {
      width: 8.5rem;
      height: 4.4rem;
      border-radius: 0.24rem;
      position: relative;
      overflow: hidden; /* 隐藏文字超出部分，保证动画效果 */
      cursor: pointer;
      display: flex;
      justify-content: center;
      left: 0.9rem;
      bottom: 0.43rem;
      /* 图片容器 */
      > .card-img {
        width: 100%;
        position: relative;
        > img {
          width: 100%;
          height: 100%;
          object-fit: cover; /* 保持图片比例，覆盖容器 */
        }
      }

      /* 文字容器：默认在底部，悬浮时上滑 */
      .text-wrap {
        position: absolute;
        width: 100%;
        margin-top: 0.6rem;
        margin-left: 1.2rem;
        /* 主文字样式（默认显示） */
        > .main-text {
          font-weight: 500;
          line-height: 0.45rem;
          color: #000;
          font-size: 0.32rem;
          margin-bottom: 0.06rem;
          white-space: pre-line; /* 解析换行符\n，实现多行文字 */
        }

        /* 子文字样式（悬浮时显示） */
        > .sub-text {
          font-weight: 400;
          line-height: 0.34rem;
          color: #666666;
          font-size: 0.24rem;
          margin-bottom: 0.06rem;
          white-space: pre-line; /* 解析换行符\n，实现多行文字 */
        }
      }
      >.word {
        text-align: center;
        position: absolute;
        bottom: 0;
        line-height: 0.17rem;
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 0.64);
      }
    }
  }

  > .wireless {
    width: 100%;
    height: 100%;
    position: relative;
    background: #FAFBFE;

    > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    > .bg {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    > .title {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000;
      line-height: 0.78rem;
    }
  }


  > .four-technology {
    position: relative;

    > .title {
      position: relative;

      bottom: 0.71rem;
      margin-bottom: 0.71rem;
      //height: 2.3rem;
      > p:nth-child(1) {
        font-weight: 500;
        font-size: 0.56rem;
        color: #000;
        line-height: 0.78rem;
        text-align: center;
      }
      > p:nth-child(2) {
        font-weight: 500;
        font-size: 0.32rem;
        color: #000;
        line-height: 0.45rem;
        text-align: center;
      }
    }

    .img-copyright {
      bottom: 1rem;
    }

    > .technology-show {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0.84rem;
      gap: 0.4rem;
      /* 特性卡片：占比调整为2列布局 */
      > .feature-card {
        width: 7.4rem;
        height: 4.8rem;
        border-radius:0.24rem;
        position: relative;
        overflow: hidden; /* 隐藏文字超出部分，保证动画效果 */
        cursor: pointer;
        display: flex;
        justify-content: center;
        left: 2rem;
        bottom: 0.4rem;
        /* 图片容器 */
        > .card-img {
          width: 100%;
          position: relative;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover; /* 保持图片比例，覆盖容器 */
          }
        }

        /* 文字容器：默认在底部，悬浮时上滑 */
        .text-wrap {
          background: linear-gradient( 180deg, rgba(245,245,247,0.65) 0%, #F5F5F7 100%);
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          bottom: 0;
          height: 1.25rem;
          width: 100%;
          text-align: center;
          /* 主文字样式（默认显示） */
          > .main-text {
            font-weight: 500;
            color: #000000;
            font-size: 0.32rem;
            line-height: 0.45rem;
          }

          /* 子文字样式（悬浮时显示） */
          > .sub-text {
            font-weight: 400;
            color: #666666;
            font-size: 0.24rem;
            line-height: 0.34rem;
          }
        }
      }
    }

    > .img-copyright {
      bottom: 0.6rem;
      color: #d4d4d4;
    }

  }

  > .research {
    width: 100%;
    height: 13.1rem;
    position: relative;
    background: #EBECF2;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .title {
      padding-top: 1.2rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
      z-index: 2;
    }

    > .sub-title {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      text-align: center;
      z-index: 2;
    }

    > .research-btn {
      padding: 0 0.24rem;
      margin-top: 0.8rem;
      font-size: 0.28rem;
      color: #FFFFFF;
      line-height: 0.51rem;
      background: #000;
      border-radius: 10rem;
      z-index: 2;
    }

    > .research-bg {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
    }
  }

  > .zhuanli {
    width: 100%;
    height: 8.94rem;
    position: relative;
    background: #FAFBFE;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .zhuanli-bg {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    > .title {
      padding-top: 1.2rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
      z-index: 2;
    }

    > .sub-title {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      text-align: center;
      z-index: 2;
      opacity: 0;
    }

    > .list {
      margin-top: 4.53rem;
      width: 100%;
      padding: 0 2.27rem;
      z-index: 2;
      display: flex;
      justify-content: space-between;

      > .item {
        width: 2.24rem;

        > p:nth-child(1) {
          font-weight: 500;
          font-size: 0.22rem;
          color: #000000;
          line-height: 0.31rem;
          text-align: center;
        }

        > p:nth-child(2) {
          margin-top: 0.12rem;
          font-size: 0.2rem;
          color: #999;
          line-height: 0.28rem;
          text-align: center;
        }
      }
    }
  }
  > .tech {
    width: 100%;
    height: 100%;
    position: relative;
    background: #FAFBFE;
    padding: 0.2rem 0.9rem;

    > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.24rem;
    }
  }

  >
  .system {
    position: relative;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    padding: 1rem 0.9rem;

    > .swiper {
      border-radius: 0.24rem;
      width: 17.4rem;
      height: 8.8rem;
    }
  }
}

.e10-other {
  position: relative;
  background: #FFF;

  > .sm-ck {
    width: 100%;
    height: 100%;
    position: relative;
    background: #FFF;
    display: flex;
    justify-content: space-between;
    padding: 0.6rem 0.9rem 1.2rem;

    > .left {
      position: relative;
      width: 8.58rem;
      height: 4.83rem;
      border-radius: 0.24rem;
      overflow: hidden;

      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      > p {
        position: absolute;
        left: 0.4rem;
        bottom: 0.4rem;
        font-weight: 500;
        font-size: 0.28rem;
        color: #FFFFFF;
        line-height: 0.39rem;
      }
    }

    > .right {
      position: relative;
      width: 8.58rem;
      height: 4.83rem;
      border-radius: 0.24rem;
      overflow: hidden;

      > video {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      > p {
        position: absolute;
        left: 0.4rem;
        bottom: 0.4rem;
        font-weight: 500;
        font-size: 0.28rem;
        color: #FFFFFF;
        line-height: 0.39rem;
      }
    }
  }

  > .full-video {
    position: relative;
    width: 100%;
    padding: 0 0.9rem;
    background: #fff;

    > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.24rem;
    }

    > .title {
      text-align: center;
      font-weight: 500;
      font-size: 0.28rem;
      color: #FFFFFF;
      line-height: 0.39rem;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 1.1rem;
    }

    > .sub-title {
      text-align: center;
      font-size: 0.2rem;
      color: #FFFFFF;
      line-height: 0.28rem;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0.61rem;
    }
  }

  > .spec {
    position: relative;
    width: 100%;
    background: #fff;

    > .title {
      padding: 1.2rem 0;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
    }

    > .person {
      position: absolute;
      bottom: 0;
      left: 1.37rem;
      width: 4.67rem;
    }

    > .content {
      position: relative;
      right: 0;
      padding: 0 0.9rem 1.2rem 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      > .top {
        position: relative;
        width: 10.84rem;
        height: 2.82rem;

        > img {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        > .title {
          position: absolute;
          left: 0.4rem;
          top: 1.13rem;
          font-weight: 500;
          font-size: 0.4rem;
          color: #000000;
          line-height: 0.56rem;
        }

        > .sub-title {
          position: absolute;
          left: 0.4rem;
          top: 1.73rem;
          font-size: 0.28rem;
          color: #000000;
          line-height: 0.39rem;
        }
      }

      > .bottom {
        margin-top: 0.24rem;
        display: flex;

        > .left {
          position: relative;
          width: 5.3rem;
          height: 5.88rem;

          > img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          > .title {
            position: absolute;
            left: 0.4rem;
            top: 0.4rem;
            font-weight: 500;
            font-size: 0.4rem;
            color: #000000;
            line-height: 0.56rem;
          }

          > .sub-title {
            position: absolute;
            left: 0.4rem;
            top: 1rem;
            font-size: 0.28rem;
            color: #000000;
            line-height: 0.39rem;
          }
        }

        > .right {
          margin-left: 0.24rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          > .top, > .bottom {
            position: relative;
            width: 5.3rem;
            height: 2.82rem;

            > img {
              position: absolute;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            > .title {
              position: absolute;
              left: 0.4rem;
              top: 0.4rem;
              font-weight: 500;
              font-size: 0.4rem;
              color: #000000;
              line-height: 0.56rem;
            }

            > .sub-title {
              position: absolute;
              left: 0.4rem;
              top: 1rem;
              font-size: 0.28rem;
              color: #000000;
              line-height: 0.39rem;
            }
          }
        }
      }
    }
  }

  > .zhuanli {
    width: 100%;
    height: 8.94rem;
    position: relative;
    background: #FAFBFE;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .zhuanli-bg {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    > .title {
      padding-top: 1.2rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
      z-index: 2;
    }

    > .sub-title {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      text-align: center;
      z-index: 2;
      opacity: 0;
    }

    > .list {
      margin-top: 4.53rem;
      width: 100%;
      padding: 0 4.85rem 0 4.65rem;
      z-index: 2;
      display: flex;
      justify-content: space-between;

      > .item {
        width: 2.24rem;

        > p:nth-child(1) {
          font-weight: 500;
          font-size: 0.22rem;
          color: #000000;
          line-height: 0.31rem;
          text-align: center;
        }

        > p:nth-child(2) {
          margin-top: 0.12rem;
          font-size: 0.2rem;
          color: #999;
          line-height: 0.28rem;
          text-align: center;
        }
      }
    }
  }
}

.h30-other {
  > .zhuanli {
    width: 100%;
    height: 8.94rem;
    position: relative;
    background: #FAFBFE;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .zhuanli-bg {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    > .title {
      padding-top: 1.2rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
      z-index: 2;
    }

    > .sub-title {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      text-align: center;
      z-index: 2;
      opacity: 0;
    }

    > .list {
      margin-top: 4.53rem;
      width: 100%;
      padding: 0 4.85rem 0 4.65rem;
      z-index: 2;
      display: flex;
      justify-content: space-between;

      > .item {
        width: 2.24rem;

        > p:nth-child(1) {
          font-weight: 500;
          font-size: 0.22rem;
          color: #000000;
          line-height: 0.31rem;
          text-align: center;
        }

        > p:nth-child(2) {
          margin-top: 0.12rem;
          font-size: 0.2rem;
          color: #999;
          line-height: 0.28rem;
          text-align: center;
        }
      }
    }
  }
}

.luolan-other {
  > .human {
    width: 100%;
    height: 13.32rem;
    position: relative;
    background: url("assets/img/product/luolan/human.png");
    background-size: cover;
    background-position-y: center;

    > .human-text {
      position: absolute;
      top: 1.2rem;
      text-align: center;
      width: 100%;
    }

    > .human-list-viewer {
      width: 9rem;
      height: 9.48rem;
      position: absolute;
      right: 0.9rem;
      top: 3.11rem;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      > .human-list-1 {
        position: relative;
        transition: all 0.4s ease-in-out;
        > .human-item {
          width: 9rem;
          height: 3rem;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

          > .human-img {
            position: absolute;
            width: 100%;
            top: 0;
          }

          > .human-text {
            font-weight: 500;
            font-size: 0.4rem;
            color: #FFFFFF;
            text-align: center;
            background: #5E54DA;
            border-radius: 10rem 10rem 10rem 10rem;
            padding: 0.07rem 0.28rem;
            z-index: 2;
            margin-left: 1.24rem;
            margin-bottom: 0.16rem;
          }

          > .human-sub-text {
            font-weight: 400;
            font-size: 0.28rem;
            color: #000000;
            line-height: 0.4rem;
            text-align: center;
            z-index: 2;
            margin-left: 0.8rem;
          }

          &.human-item-right {
            margin: 0.24rem 0;
            align-items: flex-end;

            > .human-text {
              margin-left: unset;
              margin-right: 1.2rem;
            }

            > .human-sub-text {
              margin-left: unset;
              margin-right: 0.8rem;
            }
          }
        }
      }

      > .human-list-2 {
        position: relative;
        padding-top: 1.05rem;
        display: flex;
        justify-content: space-between;
        transition: all 0.4s ease-in-out;

        > .human-item {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          width: 4.38rem;
          height: 7rem;

          > .human-img {
            position: absolute;
            width: 100%;
            top: 0;
          }

          > .human-text {
            font-weight: 500;
            font-size: 0.4rem;
            color: #FFFFFF;
            text-align: center;
            background: #5E54DA;
            border-radius: 10rem 10rem 10rem 10rem;
            padding: 0.07rem 0.28rem;
            z-index: 2;
            margin-bottom: 0.16rem;
          }

          > .human-sub-text {
            font-weight: 400;
            font-size: 0.28rem;
            color: #000000;
            line-height: 0.4rem;
            text-align: center;
            z-index: 2;
            margin-bottom: 0.8rem;
          }
        }
      }
    }

    >.human-copyright {
      position: absolute;
      left: 0.9rem;
      bottom: 0.73rem;
      font-weight: 400;
      font-size: 0.12rem;
      color: #999999;
      text-align: left;
      line-height: 0.17rem;
    }
  }

  > .zhuanli {
    width: 100%;
    height: 8.93rem;
    position: relative;
    background: #FAFBFE;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .zhuanli-bg {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    > .title {
      padding-top: 1.2rem;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
      text-align: center;
      z-index: 2;
    }

    > .sub-title {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
      text-align: center;
      z-index: 2;
      opacity: 0;
    }

    > .list {
      margin-top: 4.53rem;
      width: 100%;
      padding: 0 4.85rem 0 4.65rem;
      z-index: 2;
      display: flex;
      justify-content: space-between;

      > .item {
        width: 2.24rem;

        > p:nth-child(1) {
          font-weight: 500;
          font-size: 0.22rem;
          color: #000000;
          line-height: 0.31rem;
          text-align: center;
        }

        > p:nth-child(2) {
          margin-top: 0.12rem;
          font-size: 0.2rem;
          color: #999;
          line-height: 0.28rem;
          text-align: center;
        }
      }
    }
  }
}

#pageBottom {
  position: relative;
  height: 7.48rem;
  background: #000;
  padding: 0.8rem 0.9rem 0;
  flex-direction: column;

  .normal-text {
    font-weight: 500;
    font-size: 0.18rem;
    color: #FFFFFF;
    line-height: 0.25rem;
  }

  .small-text {
    font-weight: 400;
    font-size: 0.16rem;
    color: #999999;
    line-height: 0.22rem;

    &.active {
      color: #FFFFFF;
    }

    &:hover, &:focus, &:active {
      color: #FFFFFF;
    }
  }

  .big-text {
    font-weight: 500;
    font-size: 0.22rem;
    color: #FFFFFF;
    line-height: 0.31rem;
    letter-spacing: 0.01rem;
  }

  > .top {
    img {
      width: 1.66rem;
    }
  }

  > .content {
    flex: 1;
    padding-top: 0.8rem;
    display: flex;

    > .left {
      width: 4.8rem;

      > .social-media {
        > .list {
          margin-top: 0.1rem;
          display: flex;

          > .item {
            width: 0.44rem;
            height: 0.44rem;
            margin-left: 0.32rem;
            cursor: pointer;
            background-size: 100% !important;

            &.tiktok {
              background: url(./assets/img/index/social-media/tiktok.png) no-repeat center;

              &:hover, &:focus, &:active {
                background: url(./assets/img/index/social-media/tiktok-hover.png) no-repeat center;
              }
            }

            &.wechat {
              background: url(./assets/img/index/social-media/wechat.png) no-repeat center;

              &:hover, &:focus, &:active {
                background: url(./assets/img/index/social-media/wechat-hover.png) no-repeat center;
              }
            }

            &.xiaohongshu {
              background: url(./assets/img/index/social-media/xiaohongshu.png) no-repeat center;

              &:hover, &:focus, &:active {
                background: url(./assets/img/index/social-media/xiaohongshu-hover.png) no-repeat center;
              }
            }

            &.weibo {
              background: url(./assets/img/index/social-media/weibo.png) no-repeat center;

              &:hover, &:focus, &:active {
                background: url(./assets/img/index/social-media/weibo-hover.png) no-repeat center;
              }
            }

            &.zhihu {
              background: url(./assets/img/index/social-media/zhihu.png) no-repeat center;

              &:hover, &:focus, &:active {
                background: url(./assets/img/index/social-media/zhihu-hover.png) no-repeat center;
              }
            }

            &:first-child {
              margin-left: 0;
            }
          }
        }
      }

      > .contact {
        margin-top: 0.8rem;
        display: flex;

        > .item {
          display: flex;
          flex-direction: column;

          > .big-text {
            margin-top: 0.12rem;
          }
        }

        > .gap {
          width: 0.48rem;
          display: flex;
          align-items: center;
          justify-content: center;

          > .line {
            width: 0.01rem;
            height: 0.55rem;
            background-color: #666666;
          }
        }
      }
    }

    > .center {
      flex: 1;
      display: flex;
      justify-content: center;

      > .link-group {
        margin-right: 0.6rem;

        &:last-child {
          margin-right: 0;
        }

        > .title {
          margin-bottom: 0.27rem;
        }

        > .link-list {
          > .link-item {
            margin-bottom: 0.28rem;
            cursor: pointer;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    > .right {
      width: 2.6rem;
      text-align: center;

      > .title {
        margin-bottom: 0.32rem;
      }

      > .app-list {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .app-item {
          cursor: pointer;
          display: flex;
          flex-direction: column;

          > img {
            width: 1rem;
            margin-bottom: 0.12rem;
          }
        }
      }
    }
  }

  > .bottom {
    height: 1.23rem;
    border-top: 0.01rem solid rgba(255, 255, 255, 0.2);

    > p {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      text-align: center;

      &:nth-child(1) {
        margin-top: 0.24rem;
      }

      &:nth-child(2) {
        margin-top: 0.04rem;
      }

      &:nth-child(3) {
        margin-top: 0.2rem;
      }
    }
  }

  > .hover-img {
    position: absolute;
    background: #fff;
    width: 1.2rem;
    height: 1.2rem;
    padding: 0.06rem;
    border-radius: 0.12rem;

    > .angle {
      position: absolute;
      top: 100%;
      left: 0.53rem;
      width: 0.14rem;
      height: 0.08rem;
    }

    > img {
      width: 100%;
    }
  }
}

#goTop {
  position: fixed;
  z-index: 97;
  bottom: 1.15rem;
  right: 0.24rem;
  width: 0.52rem;
  height: 0.52rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;

  &.white {
    background: #222222;
  }

  > img {
    width: .26rem;
    height: .26rem;
  }
}

// L30
/* 网格容器：Flex实现2行2列布局 */
.l30-other {
  position: relative;
  background: #100622;
  padding-top: 0.6rem;

  .page-img-copyright {
    width: 100%;
    font-weight: 400;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 0.64);
    line-height: 0.17rem;
    pointer-events: none;
    text-align: right;
    padding-right: 0.24rem;
    padding-top: 0.24rem;
    z-index: 2;
  }

  > .product-grid {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding-top: 0.78rem;
    padding-bottom: 1.06rem;
    gap: 0.24rem;

    .img-copyright {
      bottom: 1rem;
    }

    /* 特性卡片：占比调整为2列布局 */
    > .feature-card {
      width: 7.48rem;
      height: 4.2rem;
      border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
      position: relative;
      overflow: hidden; /* 隐藏文字超出部分，保证动画效果 */
      cursor: pointer;
      display: flex;
      justify-content: center;
      left: 2.01rem;
      bottom: 0.43rem;
      /* 图片容器 */
      > .card-img {
        width: 100%;
        position: relative;
        /* 遮罩层：悬浮时显示 */
        > .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0); /* 默认透明 */
          transition: background-color 0.3s ease;
        }
        > .mask.active {
          background-color: rgba(42, 8, 86, 0.3); /* 紫色半透明遮罩，可调整透明度 */
        }
        > video {
          width: 100%;
          height: 100%;
          object-fit: cover; /* 保持图片比例，覆盖容器 */
        }
      }

      /* 文字容器：默认在底部，悬浮时上滑 */
      .text-wrap {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        bottom: 0;
        width: 100%;
        padding: 0.16rem;
        color: #fff;
        text-align: center;
        transform: translateY(0);
        transition: transform 0.3s ease;
        /* 主文字样式（默认显示） */
        > .main-text {
          font-weight: 500;
          width: 1.38rem;
          height: 0.64rem;
          color: #fff;
          font-size: 0.46rem;
          margin: 0 0 8px 0;
        }

        /* 子文字样式（悬浮时显示） */
        > .sub-text {
          font-weight: 500;
          color: #fff;
          font-size: 0.3rem;
          line-height: 0.42rem;
          margin: 0;
          white-space: pre-line; /* 解析换行符\n，实现多行文字 */
        }
      }

      /* 悬浮时文字上滑 */
      .text-wrap.slide {
        transform: translateY(-1.2rem); /* 上滑距离，可调整 */
      }
      >.word {
        text-align: center;
        position: absolute;
        bottom: 0;
        line-height: 0.17rem;
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 0.64);
      }
    }
  }
  > .course {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
    > .img-copyright {
      bottom: 0.5rem;
    }

    > p {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
    }

    > .swiper {
      border-radius: 0.24rem;
      width: 17.4rem;
      height: 8.8rem;
    }
  }

  > .advantage-pdj {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-y: center;
    padding-top: 0.5rem;
    padding-bottom: 0.7rem;

    > .title {
      > p {
        display: flex;
        justify-content: center;
        font-size: 0.3rem;
        line-height: 0.78rem;
        color: rgba(255,255,255,0.65);
        font-weight: 500;
        > span {
          font-size: 0.56rem;
          font-weight: 500;
          color: #fff;
        }
        > span:nth-child(1) {
          /* 金色渐变：从浅金到深金 */
          background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
          /* 核心属性：将背景裁剪到文字区域 */
          background-clip: text;
          /* 文字透明，显示渐变背景 */
          color: transparent;
        }
        margin-bottom: 0.66rem;
      }
      > p:nth-child(1) {
        margin-bottom: 0.16rem;
        line-height: 0.42rem;
      }
    }
    > .swiper {
      width: 100%;
      height: 7.6rem;
    }
  }

  > .rejuvenation {
    position: relative;
    padding: 0.2rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    > .about {
      position: absolute;
      display: flex;
      flex-direction: column;
      letter-spacing: 0.05rem;
      left: 2rem;
      width: 30%;
      align-items: center;
      top: 4.27rem;
      > p:nth-child(2) {
        display: flex;
        flex-direction: column;
        > span {
          font-size: 0.56rem;
          font-weight: 500;
          /* 金色渐变：从浅金到深金 */
          background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
          /* 核心属性：将背景裁剪到文字区域 */
          background-clip: text;
          /* 文字透明，显示渐变背景 */
          color: transparent;
        }
        > span:nth-child(1) {
          color: #fff;
        }
      }

      > p:nth-child(1) {
        font-size: 0.3rem;
        color: rgba(255,255,255,0.65);
        font-weight: 500;
        margin-bottom: 0.28rem;
      }
    }
  }

  > .repair-improve {
    margin: 0.22rem 2rem 1rem 2rem;
    display: flex;
    flex-direction: column;

    > .title {
      position: relative;
      top: 1.58rem;
      > p {
        display: flex;
        justify-content: center;
        font-size: 0.3rem;
        line-height: 0.78rem;
        color: rgba(255,255,255,0.65);
        font-weight: 500;
        > span {
          font-size: 0.56rem;
          font-weight: 500;
          color: #fff;
        }
        > span:nth-child(1) {
          /* 金色渐变：从浅金到深金 */
          background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
          /* 核心属性：将背景裁剪到文字区域 */
          background-clip: text;
          /* 文字透明，显示渐变背景 */
          color: transparent;
        }
      }
    }

    > img {
      width: 15.2rem;
      height: 8.8rem;
      object-fit: cover;
    }
  }

  > .vagina-improve {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 0.6rem;
    > .title {
      margin-top: 0.48rem;
      margin-bottom: 0.7rem;
      > p {
        width: 6.91rem;
        display: flex;
        justify-content: center;
        font-weight: 500;
        > span {
          font-size: 0.56rem;
          font-weight: 500;
          color: #fff;
        }
        > span:nth-child(1) {
          /* 金色渐变：从浅金到深金 */
          background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
          /* 核心属性：将背景裁剪到文字区域 */
          background-clip: text;
          /* 文字透明，显示渐变背景 */
          color: transparent;
        }
      }
    }
    > .four-intravaginal-list {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 16.8rem;
      gap: 0.24rem;
      > .intravaginal-item {
        display: flex;
        align-items: center;
        justify-content: center;
        > video {
          width: 7.2rem;
          border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
        }
        > .title {
          font-weight: 500;
          position: absolute;
          width: 2.76rem;
          height: 0.64rem;
          font-size: 0.46rem;
          color: #FFFFFF;
        }
      }
    }
  }

  > .vulva-repair, .soothing-massage {
    position: relative;
    padding: 1rem 2rem;
    display: flex;
    justify-content: center;
    > video {
      width: 15.2rem;
      object-fit: cover;
      border-radius: 0.28rem 0.28rem 0.28rem 0.28rem;
    }
    > .copyright {
      position: absolute;
      bottom: 1.1rem;
      width: 100%;
      font-weight: 400;
      font-size: 0.12rem;
      color: rgba(255, 255, 255, 0.64);
      line-height: 0.17rem;
      text-align: center;
      pointer-events: none;
    }
  }

  > .vulva-repair {
    > .title {
      position: absolute;
      top: 4.06rem;
      left: 2.99rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      > p {
        font-weight: 500;
        font-size: 0.56rem;
        height: 0.78rem;
        color: #fff;
      }
      > p:nth-child(1) {
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
      > p:nth-child(3) {
        width: 5.07rem;
        text-align: center;
        margin-top: 0.28rem;
        height: 0.84rem;
        line-height: 0.42rem;
        font-size: 0.3rem;
        color: rgba(255,255,255,0.65);
      }
    }
    > img {
      position: absolute;
      top: 2.4rem;
      right: 3.89rem;
      width: 4.64rem;
    }
  }

  > .soothing-massage {

    > .title {
      position: absolute;
      top: 4.27rem;
      left: 3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      > p {
        font-weight: 500;
        font-size: 0.56rem;
        height: 0.78rem;
        color: #fff;
      }
      > p:nth-child(1) {
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
      > p:nth-child(3) {
        width: 5.1rem;
        text-align: center;
        margin-top: 0.28rem;
        height: 0.84rem;
        line-height: 0.42rem;
        font-size: 0.3rem;
        color: rgba(255,255,255,0.65);
      }
    }
  }

  > .diastasis-recti {
    position: relative;
    > img {
      width: 100%;
      height: 10.8rem;
      object-fit: cover;
    }

    > .about {
      position: absolute;
      display: flex;
      flex-direction: column;
      left: 1.6rem;
      bottom: 4.9rem;
      width: 5.85rem;
      align-items: center;
      > p {
        line-height: 0.78rem;
        font-size: 0.56rem;
        font-weight: 500;
        color: #fff;
      }

      > p:nth-child(1) {
        font-size: 0.3rem;
        line-height: 0.42rem;
        color: rgba(255,255,255,0.45);
        font-weight: 500;
        margin-bottom: 0.28rem;
      }

      > p:nth-child(2) {
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
    }
  }

  > .electrode-pad {
    position: relative;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    > img {
      width: 15.2rem;
      height: 8.8rem;
      object-fit: cover;
    }
    > .about {
      position: absolute;
      display: flex;
      flex-direction: column;
      left: 3.4rem;
      bottom: 4.09rem;
      width: 5.56rem;
      height: 2.62rem;
      align-items: center;
      > p {
        font-weight: 500;
        line-height: 0.7rem;
        font-size: 0.5rem;
        color: #fff;
      }
      > p:nth-child(2) {
        line-height: 0.78rem;
        font-size: 0.56rem;
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
      > p:nth-child(3), p:nth-child(4) {
        font-size: 0.3rem;
        line-height: 0.42rem;
        color: rgba(255,255,255,0.65);
      }
      > p:nth-child(3) {
        margin-top: 0.28rem;
      }
    }
  }

  > .advantage {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-y: center;
    padding-top: 1.61rem;
    padding-bottom: 1.61rem;
    > .swiper {
      width: 100%;
      height: 7.6rem;
    }
    > title {
      font-weight: 500;
    }
  }

  > .international-certification {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    > .title {
      position: absolute;
      top: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      > p {
        font-weight: 500;
        line-height: 0.78rem;
        display: flex;
        justify-content: center;
        font-size: 0.3rem;
        color: #000;
        > span {
          font-size: 0.56rem;
          color: #fff;
        }
        > span:nth-child(1) {
          /* 金色渐变：从浅金到深金 */
          background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
          /* 核心属性：将背景裁剪到文字区域 */
          background-clip: text;
          /* 文字透明，显示渐变背景 */
          color: transparent;
        }
      }
      > p:nth-child(2) {
        line-height: 0.42rem;
        margin-top: 0.16rem;
        color: rgba(255,255,255,0.65);
      }
    }

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  > .patent34 {
    display: flex;
    justify-content: center;
    > .title {
      position: absolute;
      margin-top: 0.8rem;
      > p {
        line-height: 0.78rem;
        display: flex;
        justify-content: center;
        font-size: 0.56rem;
        font-weight: 500;
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }


  > .medical-patent {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    > .title {
      position: absolute;
      top: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      >p {
        display: flex;
        justify-content: center;
      }
      > p:nth-child(1) {
        line-height: 0.78rem;
        font-size: 0.56rem;
        font-weight: 500;
        /* 金色渐变：从浅金到深金 */
        background: linear-gradient(180deg, #E7CB96 0%, #FEE8BC 26%, #DDC187 54%, #FCECC7 100%);
        /* 核心属性：将背景裁剪到文字区域 */
        background-clip: text;
        /* 文字透明，显示渐变背景 */
        color: transparent;
      }
      > p:nth-child(2) {
        font-size: 0.3rem;
        line-height: 0.42rem;
        margin-top: 0.16rem;
        color: rgba(255,255,255,0.65);
      }
    }

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
<style lang="scss">
@import './assets/css/common.scss';
</style>
